import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=33ca3208&"
import script from "./UserProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./UserProfileEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports